import { initResourceCards, destroyResourceCards } from './resourceCard.js';
import { countryFiltering, topicsFiltering, formatFiltering, workshopTypeFiltering } from './resourceFiltering.js'
import typeFilter from './resourceTypeURLParser'
import fetchResource from './resourceFetcher';
import resourceURLAppender from './resourceURLAppender';
import createLoadingAnimations from './resourceLoadingAnimation.js';
import resourcePagination from './resourcePagination';
import { topicPrefiltering, countryPrefiltering, formatPrefiltering } from './resourcePrefilteredURL';
import { resourceSearch } from './resourceSearchV2.js';
import { initMobileNavigation } from './resourceMobileNavigation.js';

function resourceHub() {
    initMobileNavigation();

    //STATE
    const resourceState = {
        page: '', //blogs, research, webinars, client stories, etc.
        search: '', //The users search term
        topics: [], //Topics to filter by like coaching or executive leadership
        country: [], //Country filter
        format: [], //onsite or virtual
        type: [], // workshop types. Not to be confused with resource types. I call those pages now but still call it types when calling the resource/filter controller and filtering.
    }
    resourceState.page = typeFilter();

    //CONSTANTS
    const mainCardContainer = document.querySelector('.cardContainer');
    


    //Run pagination
    resourcePagination();

    //SPECIFICS
    //If we're on all, blogs, research, client stories, or podcasts we just activate topics filtering
    if (resourceState.page === '' || resourceState.page === 'blog' || resourceState.page === 'research' || resourceState.page === 'client_story' || resourceState.page === 'podcast') {

        //Set fetching url
        const url = '/resources/filter';
        //initiate topic filtering
        topicsFiltering.init();
        //prefilter topics from url
        topicPrefiltering(resourceState);

        //create loading animations
        createLoadingAnimations()

        //Loading containers overlays. Hide/show when finished/loading
        const cardsContainerLoadingOverlay = document.querySelector('.resource-card-container__loading-overlay');

        //HELPER FUNCTIONS
        function updateResourceCards(cards) {
            //First we destroy old cards since these timelines aren't needed
            destroyResourceCards();
            //Then we init new ones
            mainCardContainer.innerHTML = cards;
            //Let pagination run
            resourcePagination();

            //Hide the loading animation container and init the cards after a delay
            setTimeout(() => {
                cardsContainerLoadingOverlay.classList.add('resource-card-container__loading-overlay--hidden');
                initResourceCards();
            }, 200)
        }


        //handle filter resets
        const resetTopicsMobile = document.getElementById('topicFilterReset-Mobile');
        const resetTopicsDesktop = document.getElementById('topicFilterReset-Desktop');
        resetTopicsMobile.addEventListener('click',  (event) => {
            topicsFiltering.resetTopics(event);
            cardsContainerLoadingOverlay.classList.remove('resource-card-container__loading-overlay--hidden');
            resourceState.topics = topicsFiltering.filterEvent();
            resourceURLAppender({ topics: resourceState.topics, country: resourceState.country, format: resourceState.format, type: resourceState.type });
            bundleAndFetch();
        });
        resetTopicsDesktop.addEventListener('click', (event) => {
            topicsFiltering.resetTopics(event);
            cardsContainerLoadingOverlay.classList.remove('resource-card-container__loading-overlay--hidden');
            resourceState.topics = topicsFiltering.filterEvent();
            resourceURLAppender({ topics: resourceState.topics, country: resourceState.country, format: resourceState.format, type: resourceState.type });
            bundleAndFetch();
        });

        //attach event listeners to topics. When one is clicked, ask resourceFiltering to return array with updated topics array
        const topics = document.querySelectorAll('.resource-topic-filter__checkbox');
        for (const topic of topics) {
            topic.addEventListener('click', () => {
                cardsContainerLoadingOverlay.classList.remove('resource-card-container__loading-overlay--hidden');
                resourceState.topics = topicsFiltering.filterEvent();
                resourceURLAppender({ topics: resourceState.topics, country: resourceState.country, format: resourceState.format, type: resourceState.type });
                bundleAndFetch();
            })
        }

        function bundleAndFetch() {
            const requestBody = JSON.stringify({
                "types": resourceState.page,
                "topics": resourceState.topics.toString(),
                "search": ""
            })
            fetchResource(url, requestBody).then(data => updateResourceCards(data));
        }

        resourceSearch.init(resourceState);
    }
    //If we're on guides we don't actiavte anything because we currently have 2. When we have more will we activate topic filtering
    else if (resourceState.page === 'guide') {
        console.log('guides. No filtering');
    }
    //if we're on webinars, we activate topics, and countries filtering
    else if (resourceState.page === 'webinar') {
        //Set fetching url
        const url = '/resources/filter';
        //initiate topic and country filtering
        topicsFiltering.init();
        countryFiltering.init();

        //prefilter topics from url
        topicPrefiltering(resourceState);
        //prefilter countries from url
        countryPrefiltering(resourceState);

        //create loading animations
        createLoadingAnimations()

        //Loading containers overlays. Hide/show when finished/loading
        const cardsContainerLoadingOverlay = document.querySelector('.resource-card-container__loading-overlay');

        //HELPER FUNCTIONS
        function updateResourceCards(cards) {
            //First we destroy old cards since these timelines aren't needed
            destroyResourceCards();
            //Then we init new ones
            mainCardContainer.innerHTML = cards;
            //Let pagination run
            resourcePagination();

            //Hide the loading animation container and init the cards after a delay
            setTimeout(() => {
                cardsContainerLoadingOverlay.classList.add('resource-card-container__loading-overlay--hidden');
                initResourceCards();
            }, 200)
        }

        function bundleAndFetch() {
            const requestBody = JSON.stringify({
                "types": resourceState.page,
                "topics": resourceState.topics.toString(),
                "country": resourceState.country.toString(),
                "search": ""
            })
            fetchResource(url, requestBody).then(data => updateResourceCards(data));
        }


        //HANDLE TOPICS
        const resetTopicsMobile = document.getElementById('topicFilterReset-Mobile');
        const resetTopicsDesktop = document.getElementById('topicFilterReset-Desktop');
        resetTopicsMobile.addEventListener('click', (event) => {
            topicsFiltering.resetTopics(event);
            cardsContainerLoadingOverlay.classList.remove('resource-card-container__loading-overlay--hidden');
            resourceState.topics = topicsFiltering.filterEvent();
            resourceURLAppender({ topics: resourceState.topics, country: resourceState.country, format: resourceState.format, type: resourceState.type });
            bundleAndFetch();
        });
        resetTopicsDesktop.addEventListener('click', (event) => {
            topicsFiltering.resetTopics(event);
            cardsContainerLoadingOverlay.classList.remove('resource-card-container__loading-overlay--hidden');
            resourceState.topics = topicsFiltering.filterEvent();
            resourceURLAppender({ topics: resourceState.topics, country: resourceState.country, format: resourceState.format, type: resourceState.type });
            bundleAndFetch();
        });

        //attach event listeners to topics. When one is clicked, ask resourceFiltering to return array with updated topics array
        const topics = document.querySelectorAll('.resource-topic-filter__checkbox');
        for (const topic of topics) {
            topic.addEventListener('click', () => {
                cardsContainerLoadingOverlay.classList.remove('resource-card-container__loading-overlay--hidden');
                resourceState.topics = topicsFiltering.filterEvent();
                resourceURLAppender({ topics: resourceState.topics, country: resourceState.country, format: resourceState.format, type: resourceState.type });
                bundleAndFetch();
            })
        }


        //HANLDE COUNTRY
        const resetCountryMobile = document.getElementById('countryFilterReset-Mobile');
        const resetCountryDesktop = document.getElementById('countryFilterReset-Desktop');
        resetCountryMobile.addEventListener('click', (event) => {
            countryFiltering.resetCountries(event);
            cardsContainerLoadingOverlay.classList.remove('resource-card-container__loading-overlay--hidden');
            resourceState.country = countryFiltering.filterEvent();
            resourceURLAppender({ topics: resourceState.topics, country: resourceState.country, format: resourceState.format, type: resourceState.type });
            bundleAndFetch();
        })
        resetCountryDesktop.addEventListener('click', (event) => {
            countryFiltering.resetCountries(event);
            cardsContainerLoadingOverlay.classList.remove('resource-card-container__loading-overlay--hidden');
            resourceState.country = countryFiltering.filterEvent();
            resourceURLAppender({ topics: resourceState.topics, country: resourceState.country, format: resourceState.format, type: resourceState.type });
            bundleAndFetch();
        });
        const countries = document.querySelectorAll('.resource-country-filter__checkbox');
        for (const country of countries) {
            country.addEventListener('click', () => {
                cardsContainerLoadingOverlay.classList.remove('resource-card-container__loading-overlay--hidden');
                resourceState.country = countryFiltering.filterEvent();
                resourceURLAppender({ topics: resourceState.topics, country: resourceState.country, format: resourceState.format, type: resourceState.type });
                bundleAndFetch();
            })
        }

        //Finally activate search
        resourceSearch.init(resourceState);
    }
    //if we're on events we don't activate because we currently have 1. When we have more we will we activate format, type, and countries filtering
    else if (resourceState.page === 'event') {
        console.log('events. No filtering')
    }
    //If we're on workshops, we activate format, type, and countries filtering
    else if (resourceState.page === 'workshop') {
        //Set fetching url
        const url = '/workshops/filter';

        //initiate country, type, and format filtering
        countryFiltering.init();
        formatFiltering.init();

        //prefilter countries from url
        countryPrefiltering(resourceState);

        //prefilter types from url
        //TODO

        //prefilter formats from url
        formatPrefiltering(resourceState);

        //create loading animations
        createLoadingAnimations();

        //Loading containers overlays. Hide/show when finished/loading
        const cardsContainerLoadingOverlay = document.querySelector('.resource-card-container__loading-overlay');

        //HELPER FUNCTIONS
        function updateResourceCards(cards) {
            //First we destroy old cards since these timelines aren't needed
            destroyResourceCards();
            //Then we init new ones
            mainCardContainer.innerHTML = cards;
            //Let pagination run
            resourcePagination();

            //Hide the loading animation container and init the cards after a delay
            setTimeout(() => {
                cardsContainerLoadingOverlay.classList.add('resource-card-container__loading-overlay--hidden');
                initResourceCards();
            }, 200)
        }

        //Bundle and fetch method
        function bundleAndFetch() {
            const requestBody = JSON.stringify({
                "format": resourceState.format.toString(),
                "country": resourceState.country.toString(),
                "types": resourceState.type.toString(),
                "search": ""
            });
            fetchResource(url, requestBody).then(data => updateResourceCards(data));
        }

        //HANDLE FORMAT
        const resetFormatsMobile = document.getElementById('formatFilterReset-Mobile');
        const resetFormatsDesktop = document.getElementById('formatFilterReset-Desktop');
        //Reset buttons
        resetFormatsMobile.addEventListener('click', (event) => {
            formatFiltering.resetFormats(event);
            cardsContainerLoadingOverlay.classList.remove('resource-card-container__loading-overlay--hidden');
            resourceState.format = formatFiltering.filterEvent();
            resourceURLAppender({ topics: resourceState.topics, country: resourceState.country, format: resourceState.format, type: resourceState.type });
            bundleAndFetch();

        });
        resetFormatsDesktop.addEventListener('click', (event) => {
            formatFiltering.resetFormats(event);
            cardsContainerLoadingOverlay.classList.remove('resource-card-container__loading-overlay--hidden');
            resourceState.format = formatFiltering.filterEvent();
            resourceURLAppender({ topics: resourceState.topics, country: resourceState.country, format: resourceState.format, type: resourceState.type });
            bundleAndFetch();
        });
        //attach event listeners 
        const formats = document.querySelectorAll('.resource-format-filter__checkbox');
        for (const format of formats) {
            format.addEventListener('click', () => {
                cardsContainerLoadingOverlay.classList.remove('resource-card-container__loading-overlay--hidden');
                resourceState.format = formatFiltering.filterEvent();
                resourceURLAppender({ topics: resourceState.topics, country: resourceState.country, format: resourceState.format, type: resourceState.type });
                bundleAndFetch();
            })
        }

        //HANDLE TYPE
        const resetTypesMobile = document.getElementById('typeFilterReset-Mobile');
        const resetTypesDesktop = document.getElementById('typeFilterReset-Desktop');
        resetTypesMobile.addEventListener('click', (event) => {
            workshopTypeFiltering.resetTypes(event);
            cardsContainerLoadingOverlay.classList.remove('resource-card-container__loading-overlay--hidden');
            resourceState.type = workshopTypeFiltering.filterEvent();
            resourceURLAppender({ topics: resourceState.topics, country: resourceState.country, format: resourceState.format, type: resourceState.type });
            bundleAndFetch();
        });
        resetTypesDesktop.addEventListener('click', (event) => {
            workshopTypeFiltering.resetTypes(event);
            cardsContainerLoadingOverlay.classList.remove('resource-card-container__loading-overlay--hidden');
            resourceState.type = workshopTypeFiltering.filterEvent();
            resourceURLAppender({ topics: resourceState.topics, country: resourceState.country, format: resourceState.format, type: resourceState.type });
            bundleAndFetch();
        });
        const types = document.querySelectorAll('.resource-type-filter__checkbox');
        for (const type of types) {
            type.addEventListener('click', () => {
                cardsContainerLoadingOverlay.classList.remove('resource-card-container__loading-overlay--hidden');
                resourceState.type = workshopTypeFiltering.filterEvent();
                resourceURLAppender({ topics: resourceState.topics, country: resourceState.country, format: resourceState.format, type: resourceState.type });
                bundleAndFetch();
            })
        }

        //HANDLE COUNTRIES
        const resetCountriesMobile = document.getElementById('countryFilterReset-Mobile');
        const resetCountriesDesktop = document.getElementById('countryFilterReset-Desktop');
        resetCountriesMobile.addEventListener('click', (event) => {
            countryFiltering.resetCountries(event);
            cardsContainerLoadingOverlay.classList.remove('resource-card-container__loading-overlay--hidden');
            resourceState.country = countryFiltering.filterEvent();
            resourceURLAppender({ topics: resourceState.topics, country: resourceState.country, format: resourceState.format, type: resourceState.type });
            bundleAndFetch();
        });
        resetCountriesDesktop.addEventListener('click', (event) => {
            countryFiltering.resetCountries(event);
            cardsContainerLoadingOverlay.classList.remove('resource-card-container__loading-overlay--hidden');
            resourceState.country = countryFiltering.filterEvent();
            resourceURLAppender({ topics: resourceState.topics, country: resourceState.country, format: resourceState.format, type: resourceState.type });
            bundleAndFetch();
        });
        const countries = document.querySelectorAll('.resource-country-filter__checkbox');
        for (const country of countries) {
            country.addEventListener('click', () => {
                cardsContainerLoadingOverlay.classList.remove('resource-card-container__loading-overlay--hidden');
                resourceState.country = countryFiltering.filterEvent();
                resourceURLAppender({ topics: resourceState.topics, country: resourceState.country, format: resourceState.format, type: resourceState.type });
                bundleAndFetch();
            })
        }
    }

    //Finally activate the cards
    initResourceCards();
    

}

resourceHub();